import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '.';
import { loadState, saveState } from './localStorage';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = () => {
  const middlewares = [thunk];

  if (process.env.NODE_ENV !== 'production') {
    // middlewares.push(createLogger());
  }

  const persistedState = loadState();

  const store = createStore(
    rootReducer,
    persistedState,
    composeEnhancers(
      applyMiddleware(...middlewares),
    ),
  );
  store.subscribe(() => {
    saveState({
      account: store.getState().account,
    });
  });

  return store;
};

export default configureStore;
